import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      jumbo: {
        video: 'content/loop-mg10-compressed.mp4',
        under: '',
      },
    }
  },
  mutations: {

  },
  actions: {

  }
})
